import Organization from ".";

export const organizationRoutes = (data) => [
  {
    path: "/:lang/admin/organization",
    title: "Page",
    layout: "admin",
    routeType: "admin",
    component: Organization,
  },
];
